import _ from "lodash";

import { SET_ORDERED_PRODUCTS } from "../actions/types";

const initialState = {
  orderedProductsById: {}
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ORDERED_PRODUCTS: {
      return { ...state, orderedProductsById: _.keyBy(payload, "id") };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderedProductsReducer.js